<template>
  <div>
    <div class="custom-table__wrapper" :class="{ 'full-table': items.length }">
      <div v-if="selectable && !singleSelectable" class="d-flex align-items-center justify-content-end mb-4">
        <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
        <span v-if="selectedRows.length != sortedItems.length" class="link ml-4" @click="selectAll('selectAll')">
          {{ $t("vybratVse") }}
        </span>
        <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
          {{ $t("OdvybratVse") }}
        </span>
      </div>
      <div v-if="items.length > 0" class="custom-table fixed" :class="{ 'full-width': fullWidth, 'with-kebab': kebab }">
        <div class="custom-table__header d-flex align-items-center">
          <div v-if="kebab" class="custom-table__column kebab px-2" />
          <div
            v-for="(column, index) in columns"
            :key="index"
            class="custom-table__column px-2"
            :class="[column.name, { sortable: column.sortable, name: index == 0 }]"
          >
            <div
              v-if="selectable && !singleSelectable && index == 0"
              class="custom-control custom-control--checkbox"
              :class="{ checked: allOnPageSelected() }"
              @click="selectAllOnPage()"
            >
              <input type="checkbox" class="custom-control-input" />
            </div>
            <div class="title" @click="sortItemsBy(column.name)">
              <span v-if="column.alternativeName != undefined && column.alternativeName.length > 0">
                {{ $t(column.alternativeName) }}
              </span>
              <span v-else>
                {{ $t(column.name) }}
              </span>
            </div>
            <div v-if="sortBy == column.name" class="sorting">
              <span v-if="sortType == 'desc'">▼</span>
              <span v-if="sortType == 'asc'">▲</span>
            </div>
          </div>
        </div>
        <div class="custom-table__content">
          <div
            v-for="(item, index) in sortedItems.slice(
              this.page * Number(this.rowsPerPage),
              this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
            )"
            :key="index"
            :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
          >
            <div
              v-for="(column, id) in columns"
              :key="id"
              class="custom-table__column px-2"
              :class="[column.name, { sortable: column.sortable, name: id == 0 }]"
            >
              <div
                v-if="selectable && !item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox"
                :class="{
                  checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                }"
                @click="addToSelected(item)"
              >
                <input type="checkbox" class="custom-control-input" />
              </div>
              <div
                v-if="selectable && item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox disabled"
              >
                <input type="checkbox" class="custom-control-input" disabled />
              </div>

              <span>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ getNested(item, column.name) }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ nested }},</div>
                      <div v-else>{{ nested }}</div>
                    </span>
                  </span>
                  <span v-else>
                    {{ getNested(item, column.name) }}
                  </span>
                </span>
              </span>
            </div>
            <div
              v-if="kebab && itemId"
              id="kebab"
              ref="kebab"
              class="custom-table__column kebab px-2 d-flex justify-content-end"
              :class="{
                opened: openedItem[itemId] == item[itemId] && showKebab
              }"
            >
              <div class="dropdown-actions">
                <div class="atom-icon mr-0" @click="openKebab(item)">
                  <img src="@/assets/icons/menu/ico-kebab.svg" />
                </div>
                <div
                  v-if="openedItem[itemId] == item[itemId] && showKebab"
                  v-click-outside="closeKebab"
                  class="dropdown-actions__wrapper"
                >
                  <div class="dropdown-actions__inner" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="items.length > 0"
        class="custom-table fixed fixed-last"
        :class="{ 'full-width': fullWidth, 'with-kebab': kebab }"
      >
        <div class="custom-table__header d-flex align-items-center">
          <div v-if="kebab" class="custom-table__column kebab px-2" />
          <div
            v-for="(column, index) in columns"
            :key="index"
            class="custom-table__column px-2"
            :class="[column.name, { sortable: column.sortable, name: index == 0 }]"
          >
            <div
              v-if="selectable && !singleSelectable && index == 0"
              class="custom-control custom-control--checkbox"
              :class="{ checked: allOnPageSelected() }"
              @click="selectAllOnPage()"
            >
              <input type="checkbox" class="custom-control-input" />
            </div>
            <div class="title" @click="sortItemsBy(column.name)">
              <span v-if="column.alternativeName != undefined && column.alternativeName.length > 0">
                {{ $t(column.alternativeName) }}
              </span>
              <span v-else>
                {{ $t(column.name) }}
              </span>
            </div>
            <div v-if="sortBy == column.name" class="sorting">
              <span v-if="sortType == 'desc'">▼</span>
              <span v-if="sortType == 'asc'">▲</span>
            </div>
          </div>
        </div>
        <div class="custom-table__content">
          <div
            v-for="(item, index) in sortedItems.slice(
              this.page * Number(this.rowsPerPage),
              this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
            )"
            :key="index"
            :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
          >
            <div
              v-if="kebab && itemId"
              id="kebab"
              ref="kebab"
              class="custom-table__column kebab px-2 d-flex justify-content-end"
              :class="{
                opened: openedItem[itemId] == item[itemId] && showKebab
              }"
            >
              <div class="dropdown-actions">
                <div class="atom-icon mr-0" @click="openKebab(item)">
                  <img src="@/assets/icons/menu/ico-kebab.svg" />
                </div>
                <div
                  v-if="openedItem[itemId] == item[itemId] && showKebab"
                  v-click-outside="closeKebab"
                  class="dropdown-actions__wrapper"
                >
                  <div class="dropdown-actions__inner">
                    <slot name="actions" :item="openedItem" :runAction="runAction" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(column, id) in columns"
              :key="id"
              class="custom-table__column px-2"
              :class="[column.name, { sortable: column.sortable, name: id == 0 }]"
            >
              <div
                v-if="selectable && !item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox"
                :class="{
                  checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                }"
                @click="addToSelected(item)"
              >
                <input type="checkbox" class="custom-control-input" />
              </div>
              <div
                v-if="selectable && item.notSelectable && id == 0"
                class="custom-control custom-control--checkbox disabled"
              >
                <input type="checkbox" class="custom-control-input" disabled />
              </div>

              <span>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ getNested(item, column.name) }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ nested }},</div>
                      <div v-else>{{ nested }}</div>
                    </span>
                  </span>
                  <span v-else>
                    {{ getNested(item, column.name) }}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="items.length > 0"
        class="custom-table relative"
        :class="{ 'full-width': fullWidth, 'with-kebab': kebab }"
      >
        <div class="custom-table__inner" :class="{ 'full-width': fullWidth, 'with-kebab': kebab }">
          <div class="custom-table__header d-flex align-items-center">
            <div
              v-for="(column, index) in columns"
              :key="index"
              class="custom-table__column px-2"
              :class="[column.name, { sortable: column.sortable, name: index == 0 }]"
            >
              <div
                v-if="selectable && !singleSelectable && index == 0"
                class="custom-control custom-control--checkbox"
                :class="{ checked: isSelectedAllOnPage }"
                @click="selectAll()"
              >
                <input type="checkbox" class="custom-control-input" />
              </div>
              <div class="title" @click="sortItemsBy(column.name)">
                <span v-if="column.alternativeName != undefined && column.alternativeName.length > 0">
                  {{ $t(column.alternativeName ?? "") }}
                </span>
                <span v-else>
                  {{ $t(column.name ?? "") }}
                </span>
              </div>
              <div v-if="sortBy == column.name" class="sorting">
                <span v-if="sortType == 'desc'">▼</span>
                <span v-if="sortType == 'asc'">▲</span>
              </div>
            </div>
            <div v-if="kebab" class="custom-table__column kebab px-2" />
          </div>
          <div class="custom-table__content">
            <div
              v-for="(item, index) in sortedItems.slice(
                this.page * Number(this.rowsPerPage),
                this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
              )"
              :key="index"
              :class="['custom-table__row d-flex', item.customRowClass ? item.customRowClass : '']"
            >
              <div
                v-for="(column, id) in columns"
                :key="id"
                class="custom-table__column px-2"
                :class="[column.name, { sortable: column.sortable, name: id == 0 }]"
              >
                <div
                  v-if="selectable && id == 0"
                  class="custom-control custom-control--checkbox"
                  :class="{
                    checked: selectedRows.filter((e) => e[itemId] === item[itemId]).length > 0
                  }"
                  @click="addToSelected(item)"
                >
                  <input type="checkbox" class="custom-control-input" />
                </div>
                <span v-if="column.action" @click="$emit(column.action, item)">
                  <span class="link-gray font-weight-bolder">
                    <span>{{ $t(String(getNested(item, column.name) ?? "")) }}</span>
                  </span>
                </span>
                <span v-else>
                  <span v-if="column.nested">
                    <span v-for="(nested, index) in getNested(item, column.name)" :key="index">
                      <div v-if="index + 1 < getNested(item, column.name).length">{{ $t(String(nested ?? "")) }},</div>
                      <div v-else>{{ $t(String(nested ?? "")) }}</div>
                    </span>
                  </span>
                  <span v-else>{{ $t(String(getNested(item, column.name) ?? "")) }}</span>
                </span>
              </div>
              <div
                v-if="kebab && itemId"
                id="kebab"
                ref="kebab"
                class="custom-table__column kebab px-2 d-flex justify-content-end"
                :class="{
                  opened: openedItem[itemId] === item[itemId] && showKebab
                }"
              >
                <div class="dropdown-actions">
                  <div class="atom-icon mr-0" @click="openKebab(item)">
                    <img src="@/assets/icons/menu/ico-kebab.svg" />
                  </div>
                  <div
                    v-if="openedItem[itemId] === item[itemId] && showKebab"
                    v-click-outside="closeKebab"
                    class="dropdown-actions__wrapper"
                  >
                    <div class="dropdown-actions__inner">
                      <slot name="actions" :runAction="runAction" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-loader v-else-if="loading" class="mt-3" />
      <div v-else class="my-5">{{ emptyText ? $t(emptyText) : $t("nicKZobrazeni") }}.</div>
    </div>
    <div v-if="sortedItems.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <div class="custom-table__footer__row d-flex align-items-center justify-content-between">
        <div class="custom-table__footer__rows d-flex align-items-center">
          <span>{{ $t("pocetRadkuNaStrance") }}</span>
          <div class="custom-control__select custom-control__select--small">
            <div
              class="custom-control__select__selected"
              :class="{ opened: openedRowsSelect }"
              @click="openedRowsSelect = openedRowsSelect ? false : true"
            >
              <span>{{ rowsPerPage }}</span>
            </div>
            <div class="custom-control__select__options" :class="{ opened: openedRowsSelect }">
              <div
                v-for="rows in [10, 20, 50, 100]"
                :key="rows"
                class="custom-control__select__option d-flex align-items-center"
                @click="
                  () => {
                    rowsPerPage = rows
                    openedRowsSelect = false
                  }
                "
              >
                <span class="font-weight-light">{{ rows }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="custom-table__paginator">
          <div class="custom-table__paginator__control prev">
            <div v-if="page > 0" class="custom-table__paginator__link" @click="page--" />
          </div>
          <div v-if="page == 0 && rowsPerPage < sortedItems.length" class="custom-table__paginator__pages">
            1 - {{ rowsPerPage }} {{ $t("pagingZ") }} {{ sortedItems.length }}
          </div>
          <div v-else-if="page == 0 && rowsPerPage > sortedItems.length" class="custom-table__paginator__pages">
            1 - {{ sortedItems.length }} {{ $t("pagingZ") }}
            {{ sortedItems.length }}
          </div>
          <div
            v-else-if="sortedItems.length <= page * rowsPerPage + Number(rowsPerPage)"
            class="custom-table__paginator__pages"
          >
            {{ page * rowsPerPage + 1 }} - {{ sortedItems.length }} z
            {{ sortedItems.length }}
          </div>
          <div v-else class="custom-table__paginator__pages">
            {{ page * rowsPerPage + 1 }} - {{ page * Number(rowsPerPage) + Number(rowsPerPage) }} z
            {{ sortedItems.length }}
          </div>
          <div class="custom-table__paginator__control next">
            <div
              v-if="page < sortedItems.length / Number(rowsPerPage) - 1"
              class="custom-table__paginator__link"
              @click="page++"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"

import Loader from "@/components/loader.vue"

export default {
  components: {
    "app-loader": Loader
  },
  props: {
    columns: Array,
    items: Array,
    fullWidth: Boolean,
    loading: Boolean,
    emptyText: String,
    kebab: Boolean,
    itemId: String,
    selectable: Boolean,
    singleSelectable: Boolean,
    defaultSortingIndex: {
      type: Number,
      default: 0
    },
    defaultSortType: {
      type: String,
      default: "asc"
    }
  },
  data() {
    return {
      sortType: "asc",
      sortBy: "",
      sortedItems: [],
      rowsPerPage: 20,
      page: 0,
      openedItem: {},
      openedRowsSelect: false,
      selectedRows: [],
      isSelectedAllOnPage: false,
      showKebab: false
    }
  },
  computed: {},
  watch: {
    rowsPerPage() {
      this.page = 0
      this.$emit("pageSizeChange", this.rowsPerPage)
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.$emit("pageChange", this.page)
      this.allOnPageSelected()
    },
    items() {
      console.log("watch items")
      this.sortedItems = [].concat(this.items)
      this.sortBy = this.columns[this.defaultSortingIndex].name
      this.sortItemsBy(this.sortBy, true)
    },
    openedItem() {
      this.openedItem[this.itemId] != undefined ? this.$emit("opened", this.openedItem) : this.$emit("opened", null)
    },
    selectedRows() {
      this.selectedRows.length > 0 ? this.$emit("selectedRows", this.selectedRows) : this.$emit("selectedRows", null)
    }
  },
  mounted() {
    this.sortType = this.defaultSortType

    this.selectedRows = []
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.sortedItems = [].concat(this.items)
    this.sortBy = this.columns[this.defaultSortingIndex].name

    if (this.defaultSortingIndex > 0) {
      var self = this
      setTimeout(function () {
        self.sortItemsBy(self.sortBy, true)
      }, 1)
    }
  },
  methods: {
    sortItemsBy(sortBy, skipSortType) {
      console.log("sorting")
      let sorted
      this.sortBy = sortBy

      // we need to skip sortType change after language change for example
      if (!skipSortType) {
        if (this.sortType == "asc") {
          this.sortType = "desc"
        } else {
          this.sortType = "asc"
        }
      }

      sorted = _.orderBy(this.sortedItems, [(item) => item[sortBy].toLowerCase()], this.sortType)

      console.log(this.sortType)
      console.log(this.sortBy)

      this.sortedItems = sorted
    },
    getNested(item, name) {
      let splited = name.split(".")
      if (splited.length == 1) {
        return item[name]
      } else if (splited.length == 2) {
        return item[splited[0]][splited[1]]
      } else if (splited.length == 3) {
        return item[splited[0]][splited[1]][splited[2]]
      } else if (splited.length == 4) {
        return item[splited[0]][splited[1]][splited[2]][splited[3]]
      }
    },
    openKebab(item) {
      this.showKebab = true
      this.openedItem = this.openedItem == item ? {} : item
    },
    runAction() {
      this.$emit
    },
    addToSelected(item) {
      if (this.selectedRows.filter((e) => e[this.itemId] === item[this.itemId]).length > 0) {
        const index = this.selectedRows.map((e) => e[this.itemId]).indexOf(item[this.itemId])
        this.selectedRows.splice(index, 1)
      } else {
        if (this.singleSelectable) {
          this.selectedRows = []
        }
        this.selectedRows.push(item)
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.sortedItems
        .slice(this.page * this.rowsPerPage, Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage))
        .filter((a) => a.notSelectable != true)

      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])
      console.log("allItemsId")
      console.log(allItemsId)
      console.log("itemsOnPageId")
      console.log(itemsOnPageId)
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    selectAllOnPage() {
      let itemsOnPage = this.sortedItems
        .slice(this.page * this.rowsPerPage, Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage))
        .filter((a) => a.notSelectable != true)

      let itemsOnPageId = itemsOnPage.map((d) => d[this.itemId])
      let allItemsId = Array.from(this.selectedRows).map((d) => d[this.itemId])
      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        let indexes = []
        itemsOnPage.forEach((element) => {
          indexes.push(Array.from(this.selectedRows).indexOf(element))
        })
        this.selectedRows.splice(indexes[0], indexes.length)
      } else {
        let indexes = []
        let same = []
        this.selectedRows.forEach((selected) => {
          let filteredArray = itemsOnPage.filter((e) => e[this.itemId] === selected[this.itemId])
          same.push(filteredArray[0])
        })
        same.forEach((element) => {
          if (element != undefined) {
            indexes.push(this.selectedRows.findIndex((obj) => obj[this.itemId] == element[this.itemId]))
          }
        })
        for (var i = indexes.length - 1; i >= 0; i--) {
          this.selectedRows.splice(indexes[i], 1)
        }
        this.selectedRows =
          this.selectedRows.length > 0
            ? this.selectedRows.concat.apply(this.selectedRows, itemsOnPage)
            : [].concat.apply([], itemsOnPage)

        let filternotSelectable = []
        this.selectedRows.forEach((selected) => {
          console.log(selected.notSelectable)
          if (selected.notSelectable != true) {
            console.log(selected)
            filternotSelectable.push(selected)
          }
        })
        this.selectedRows = filternotSelectable
        console.log("this.selectedRows")
        console.log(this.selectedRows)
      }
    },
    selectAll(type) {
      if (type === "deselect") {
        this.selectedRows = []
      } else if (type === "selectAll") {
        console.log("selectAll()")
        console.log(this.sortedItems)
        this.sortedItems.forEach((selected) => {
          console.log(selected.notSelectable)
          if (selected.notSelectable != true) {
            console.log(selected)
            this.selectedRows.push(selected)
          }
        })
      }
    },
    openModal1(item) {
      this.$emit("openModal1", item)
    },
    closeKebab() {
      this.showKebab = false
      this.openedItem = {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
